import { render } from "./InvoicesTable.vue?vue&type=template&id=2c0b90e4"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__